import React, { useEffect } from 'react';
import Select from "../../forms/inputs/Select";
import { useTranslation } from 'react-i18next';
import {PAGES} from "../../services/interactions/audit.trail";

const rOptions = (option) => {
    if (option === 'all') { return ({ read: true, edit: true, create: true }) }
    if (option === 'edit') { return ({ read: true, edit: true, create: false }) }
    if (option === 'read') { return ({ read: true, edit: false, create: false }) }
}

const ROLE_OPTIONS = [
    { label: 'Administrator', value: 'admin' },
    { label: 'Clinician', value: 'clinician' },
    { label: 'Staff', value: 'staff' },
    { label: 'Read only', value: 'read' },
    { label: 'Command only', value: 'command-only' }
];

const ROLES_TO_LABEL = [
    {
        option: 'admin', roles: {
            alertsBase: rOptions('all'),
            alertsPreference: rOptions('all'),
            devicesAssign: rOptions('all'),
            programsBase: rOptions('all'),
            programsEnroll: rOptions('all'),
            programsRules: rOptions('all'),
            userClinicians: rOptions('all'),
            userPatients: rOptions('all'),
            userCredentials: rOptions('all'),
        }
    },
    {
        option: 'clinician', roles: {
            alertsBase: rOptions('all'),
            alertsPreference: rOptions('all'),
            devicesAssign: rOptions('all'),
            programsBase: rOptions('read'),
            programsEnroll: rOptions('all'),
            programsRules: rOptions('all'),
            userClinicians: rOptions('edit'),
            userPatients: rOptions('all'),
            userCredentials: rOptions('edit'),
        }
    },
    {
        option: 'staff', roles: {
            alertsBase: rOptions('edit'),
            alertsPreference: rOptions('read'),
            devicesAssign: rOptions('all'),
            programsBase: rOptions('read'),
            programsEnroll: rOptions('all'),
            programsRules: rOptions('all'),
            userClinicians: rOptions('edit'),
            userPatients: rOptions('all'),
            userCredentials: rOptions('edit'),
        }
    },
    {
        option: 'read', roles: {
            alertsBase: rOptions('read'),
            alertsPreference: rOptions('read'),
            devicesAssign: rOptions('read'),
            programsBase: rOptions('read'),
            programsEnroll: rOptions('read'),
            programsRules: rOptions('read'),
            userClinicians: rOptions('read'),
            userPatients: rOptions('read'),
            userCredentials: rOptions('read'),
        }
    },
    {
        option: 'command-only', roles: {
            alertsBase: rOptions('all'),
            alertsPreference: rOptions('all'),
            devicesAssign: rOptions('all'),
            programsBase: rOptions('read'),
            programsEnroll: rOptions('all'),
            programsRules: rOptions('all'),
            userClinicians: rOptions('edit'),
            userPatients: rOptions('all'),
            userCredentials: rOptions('edit'),
        }
    },
];

const userRolesToOptionValue = (role) => {
    if (!role) {
        return ROLE_OPTIONS[1];
    }
    const _role = ROLE_OPTIONS.find(opt => opt.value === role);
    if (!_role) {
        return ROLE_OPTIONS[1];
    }
    return _role;
}

export const userOptionsToRoles = (optionValue) => {
    const role = ROLES_TO_LABEL.find(opt => optionValue === opt.option);
    if (!role) {
        return ROLES_TO_LABEL[0].roles;
    }
    return {roles: role.roles, option:role.option};
}

export const UserCreateFormRole = ({event, role, onChange, onLabelChange}) => {
    const {t} = useTranslation(['users'])

    useEffect(() => {
        const defaultRole = ROLES_TO_LABEL.find(r => r.option === 'clinician');
        if (onChange) {
            onChange(defaultRole.roles);
        }
        if (onLabelChange) {
            onLabelChange(defaultRole.option);
        }
    }, []);
    const handleRoleChange = (value) => {
        const role = userOptionsToRoles(value);
        console.log('Role: ', role);
        if (onChange) {
            onChange(role.roles);
        }
        if (onLabelChange) {
            onLabelChange(role.option);
        }
    }
    return (
        <Select value={userRolesToOptionValue(role).value} onChange={handleRoleChange}
            label={t('user-role')} placeholder={t('user-role')} options={ROLE_OPTIONS} event={event} />

    )
}

export default UserCreateFormRole;
